module.exports = __webpack_public_path__ + "img/DW365-192.51ee66ea.jpg";